import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { AlertModule } from 'ngx-bootstrap/alert';
import { CardModule, FormModule, GridModule, ModalModule } from '@coreui/angular';
import { IconModule } from '@coreui/icons-angular';
import { TranslateModule } from '@ngx-translate/core';

import { HasRolesDirective } from "../directives/has-roles.directive";
import { FormFormasPagoComponent } from "./form-formas-pago/form-formas-pago.component";
import { FormatearCodigoCerosPipe } from "./pipe/formatearCodigoCeros.pipe";
import { LocalDateTimePipe } from "./pipe/localDateTime.pipe";
import { ToastMensajeComponent } from "./toast-mensaje/toast-mensaje.component";
import { ClienteResumenDetalleComponent } from "./cliente-resumen-detalle/cliente-resumen-detalle.component";
import { ModalFormComponent } from "./generic-modal-form/modal-form.component";
import { EditFormComponent } from "./edit-form/edit-form.component";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { PrintPagoModalComponent } from "./print-pago-modal/print-pago-modal.component";
import { IconComponent } from "./icon/icon.component";
import { VerDevolucionModalComponent } from "./ver-devolucion-modal/ver-devolucion-modal.component";
import { DataLoadingComponent } from "../data-loading/data-loading.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    AlertModule.forRoot(),
    CardModule,
    FormModule,
    GridModule,
    ModalModule,
    IconModule,
    TranslateModule,
    BsDatepickerModule.forRoot(),
  ],
  declarations: [
    HasRolesDirective,
    FormFormasPagoComponent,
    FormatearCodigoCerosPipe,
    LocalDateTimePipe,
    ToastMensajeComponent,
    ClienteResumenDetalleComponent,
    ModalFormComponent,
    EditFormComponent,
    PrintPagoModalComponent,
    IconComponent,
    VerDevolucionModalComponent,
    DataLoadingComponent
  ],
  exports: [
    HasRolesDirective,
    FormFormasPagoComponent,
    FormatearCodigoCerosPipe,
    LocalDateTimePipe,
    ToastMensajeComponent,
    ClienteResumenDetalleComponent,
    ModalFormComponent,
    EditFormComponent,
    PrintPagoModalComponent,
    IconComponent,
    VerDevolucionModalComponent,
    DataLoadingComponent
  ],
  providers: [
    DatePipe
  ]
})
export class AppSharedModule { }
